import { getFileTypeByName } from "@/core/Utils/file.utils";

export default class OfferFile {
  constructor({
    name = "",
    url = "",
    offerFile = "",
    id = NaN,
    signaturePage = 1,
  } = {}) {
    this.offerFile = offerFile;
    this.name = name;
    this.url = url;
    this.id = id;
    this.signaturePage = signaturePage;
  }

  get fileType() {
    return getFileTypeByName(this.name);
  }
}
